import React, { useRef, useState, useEffect } from "react";

/**
 * Wraps children in a div that fades + slides up when it enters the viewport.
 * Props:
 *   delay  — animation-delay in seconds (default 0)
 *   threshold — intersection threshold 0-1 (default 0.08)
 */
function AnimatedSection({ children, delay = 0, threshold = 0.08 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return (
    <div
      ref={ref}
      style={{
        opacity:    visible ? 1 : 0,
        transform:  visible ? "translateY(0)" : "translateY(36px)",
        transition: `opacity 0.75s ease ${delay}s, transform 0.75s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

export default AnimatedSection;
